import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNews, setNews } from '../actions/news';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  CircularProgress,
} from '@mui/material';

const NewsLine = () => {
  const dispatch = useDispatch();
  const { news, isLoading } = useSelector((state) => state.news);
  const { authData, isLogin } = useSelector((state) => state.auth);

  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');

  useEffect(() => {
    dispatch(getNews());
  }, [dispatch]);

  const handleOpen = () => {
    setText(news);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleSave = () => {
    dispatch(setNews(text));
    setOpen(false);
  };

  // If there's no news and user isn't admin → show nothing
  if (!isLoading && (!news || news.trim() === '') && !(isLogin && authData?.role === '0')) {
    return null;
  }

  // If no news, show "Add News" button for admin
  if (!isLoading && (!news || news.trim() === '')) {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          margin: '10px 0',
        }}
      >
        <Button
          variant="contained"
          size="medium"
          color="secondary"
          onClick={handleOpen}
          style={{
            backgroundColor: '#c62828',
            color: 'white',
            fontWeight: 500,
            textTransform: 'none',
            padding: '6px 16px',
            fontSize: '14px',
          }}
        >
          Add News
        </Button>

        {/* Add News Dialog */}
        <Dialog open={open} onClose={handleClose} fullWidth>
          <DialogTitle>Add News Line</DialogTitle>
          <DialogContent style={{ paddingBottom: '0px' }}>
            <TextField
              autoFocus
              margin="dense"
              label="News Text"
              fullWidth
              variant="standard"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Enter the latest news"
              multiline
              minRows={2}
              InputProps={{
                style: {
                  paddingBottom: 0, // reduce bottom spacing
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSave}>Save</Button>
            <Button onClick={handleClose}>Cancel</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  // Otherwise, show the full news (multi-line, shiny red, thin)
  return (
    <>
      <div
        style={{
          width: '100%',
          color: '#ff1744', // brighter red
          fontSize: '16px', // larger text
          fontWeight: 300,
          fontFamily: 'Arial, Helvetica, sans-serif',
        //   textShadow:
        //     '0 0 5px rgba(255, 0, 0, 0.6), 0 0 10px rgba(255, 80, 80, 0.6), 0 0 20px rgba(255, 0, 0, 0.4)',
          textAlign: 'center',
          margin: '16px 0',
          padding: '5px 10px',
          whiteSpace: 'normal', // allows multiple lines
        //   lineHeight: '1.6',
          position: 'relative',
          transition: 'all 0.3s ease',
        }}
      >
        {isLoading ? (
          <div style={{ textAlign: 'center' }}>
            <CircularProgress size={22} color="inherit" />
          </div>
        ) : (
          <div>
            {news}
          </div>
        )}

        {/* Admin Edit Button */}
        {isLogin && authData?.role === '0' && (
          <Button
            variant="contained"
            size="medium"
            onClick={handleOpen}
            style={{
              position: 'absolute',
              right: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: '#c62828',
              color: 'white',
              fontWeight: 500,
              fontSize: '14px',
              padding: '5px 13px',
              textTransform: 'none',
              borderRadius: '6px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
            }}
          >
            Edit
          </Button>
        )}
      </div>

      {/* Edit News Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Edit News Line</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="News Text"
            fullWidth
            variant="standard"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Enter or clear news text"
            multiline
            minRows={1}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave}>Save</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewsLine;
